var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ia-cliente-contratos" },
    [
      _c(
        _vm.navegavel ? "button" : "div",
        {
          tag: "component",
          staticClass: "ia-cliente-contratos__rotulo ia-texto-selo",
          attrs: { type: _vm.navegavel ? "button" : null },
          on: { click: _vm.aoClicar }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.rotulo))]),
          _vm.navegavel
            ? _c("icon-svg", {
                attrs: {
                  name: "arrow-left",
                  size: _vm.TAMANHO_CHEVRON,
                  color: "var(--neutral-600)"
                }
              })
            : _vm._e(),
          !_vm.carregando
            ? _c(
                "span",
                {
                  staticClass: "ia-sidebar-contador ml-auto",
                  attrs: { "data-test": "ia-cliente-contratos-contador" }
                },
                [_vm._v(" " + _vm._s(_vm.contador) + " ")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm.carregando
        ? _c(
            "ul",
            { staticClass: "ia-cliente-contratos__lista" },
            _vm._l(_vm.LINHAS_PENDENTES, function(linha) {
              return _c(
                "li",
                { key: linha.chave },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: _vm.ICONE,
                      size: _vm.TAMANHO_ICONE,
                      color: "var(--neutral-300)"
                    }
                  }),
                  _c(
                    "span",
                    { staticClass: "ia-cliente-contratos__pendente" },
                    [
                      _c(
                        "BaseLoadingSkeleton",
                        _vm._b({}, "BaseLoadingSkeleton", _vm.CAIXA_NOME, false)
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        : _vm.vazio
        ? _c(
            "p",
            { staticClass: "ia-cliente-contratos__vazio ia-texto-auxiliar" },
            [_vm._v("Nenhum contrato")]
          )
        : _c(
            "ul",
            { staticClass: "ia-cliente-contratos__lista" },
            _vm._l(_vm.itens, function(item) {
              return _c(
                "li",
                { key: item.chave },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: _vm.ICONE,
                      size: _vm.TAMANHO_ICONE,
                      color: "var(--neutral-700)"
                    }
                  }),
                  _c(
                    "span",
                    {
                      staticClass:
                        "ia-cliente-contratos__nome ia-texto-auxiliar"
                    },
                    [_vm._v(_vm._s(item.nome))]
                  ),
                  item.id
                    ? _c(
                        "button",
                        {
                          staticClass: "ia-cliente-contratos__baixar",
                          attrs: {
                            type: "button",
                            disabled: Boolean(_vm.baixando),
                            title: "Baixar " + item.nome,
                            "aria-label": "Baixar " + item.nome
                          },
                          on: {
                            click: function($event) {
                              return _vm.baixar(item)
                            }
                          }
                        },
                        [
                          _vm.baixando === item.id
                            ? _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  size: "14",
                                  width: "2",
                                  color: "var(--primary)"
                                }
                              })
                            : _c("icon-svg", {
                                attrs: {
                                  name: _vm.ICONE_BAIXAR,
                                  size: _vm.TAMANHO_ICONE,
                                  color: "var(--neutral-600)"
                                }
                              })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }